﻿﻿import { MoveTrackerStatusType } from '../enums/index';

export interface IMoveTrackerStatus {
    type: MoveTrackerStatusType;
    status: number;
    complete: boolean;
    overage: string;
    scheduleDateTime: string;
    scheduleDateTimeTz: string;
    scheduleDateTimeLocal: string;
    actualDateTime: string;
    actualDateTimeTz: string;
    actualDateTimeLocal: string;
    arrivalDateTimeActual: string;
    arrivalDateTimeActualTz: string;
    flightNumber: string;
    tenderToAirlineDateTimeActual: string;
    tenderToAirlineDateTimeActualTz: string;
}
